import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

export const useAccountActivityChart = (
  accountActivityData: any,
  accountList: Record<string, string> | undefined
) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return useMemo(() => {
    if (!accountActivityData?.searchEvents || !accountActivityData?.clickEvents || !accountList) {
      return null;
    }

    const accountSearchCounts: Record<string, number> = {};
    const accountClickCounts: Record<string, number> = {};

    // Process search events
    accountActivityData.searchEvents.forEach((event: any) => {
      const accountId = event.account;
      accountSearchCounts[accountId] = (accountSearchCounts[accountId] || 0) + event.count;
    });

    // Process click events
    accountActivityData.clickEvents.forEach((event: any) => {
      const accountId = event.account;
      accountClickCounts[accountId] = (accountClickCounts[accountId] || 0) + event.count;
    });

    const activeAccounts = Array.from(new Set([
      ...Object.keys(accountSearchCounts),
      ...Object.keys(accountClickCounts)
    ]));

    const labels = activeAccounts.map(accountId => accountList[accountId] || accountId);
    const searchData = activeAccounts.map(accountId => accountSearchCounts[accountId] || 0);
    const clickData = activeAccounts.map(accountId => accountClickCounts[accountId] || 0);

    return {
      labels,
      datasets: [
        {
          label: t('statistics.legend.searches', 'Searches'),
          data: searchData,
          backgroundColor: theme.palette.primary.main,
          stack: 'combined'
        },
        {
          label: t('statistics.legend.journalClicks', 'Clicks'),
          data: clickData,
          backgroundColor: theme.palette.warning.main,
          stack: 'combined'
        }
      ]
    };
  }, [accountActivityData, accountList, t, theme]);
};